<template>
    <div class="block-editor google-business-update-review-status">
        <section>
            <div class="title">{{ $t('auto.googleBusinessUpdateReviewStatusReviewId') }}</div>
            <TiptapEditor placeholder="Google Business Review ID" :show-attributes="true" v-model="clone.reviewId" automation-mode />
            <small>{{ $t('auto.googleBusinessUpdateReviewStatusDurumuGNcellenecekYorumunIdsi') }}</small>
        </section>
        <section>
            <div class="title">{{ $t('auto.googleBusinessUpdateReviewStatusYeniDurum') }}</div>
            <a-select v-model="clone.status" class="classic-select" :placeholder="$t('auto.googleBusinessUpdateReviewStatusDurumSeIniz')">
                <a-select-option value="new">{{ $t('auto.googleBusinessUpdateReviewStatusYeniNew') }}</a-select-option>
                <a-select-option value="replied">{{ $t('auto.googleBusinessUpdateReviewStatusYanTlandReplied') }}</a-select-option>
                <a-select-option value="resolved">{{ $t('auto.googleBusinessUpdateReviewStatusZLdResolved') }}</a-select-option>
            </a-select>
        </section>
        <section>
            <div class="title">{{ $t('auto.googleBusinessUpdateReviewStatusAtanacakTemsilciOpsiyonel') }}</div>
            <a-select v-model="clone.assigneeId" class="classic-select" :placeholder="$t('auto.googleBusinessUpdateReviewStatusTemsilciSeIniz')" allow-clear>
                <a-select-option v-for="user in users" :key="user._id" :value="user._id">
                    {{ user.name }}
                </a-select-option>
            </a-select>
            <small>{{ $t('auto.googleBusinessUpdateReviewStatusYorumuBirTemsilciyeAtayabilirsiniz') }}</small>
        </section>
    </div>
</template>

<script>
import _ from "lodash";
import { mapState } from "vuex";
import TiptapEditor from "../../../../Chatbot/pages/dashboard/common/TiptapEditor.vue";
export default {
    name: "GoogleBusinessUpdateReviewStatus",
    components: {
        TiptapEditor,
    },
    props: ["value"],
    data() {
        return {
            clone: _.cloneDeep({
                reviewId: "",
                status: "new",
                assigneeId: null,
                ...this.value
            }),
        };
    },
    computed: {
        ...mapState({
            users: (state) => state.user.users.data,
        }),
    },
    watch: {
        clone: {
            deep: true,
            handler(newValue) {
                this.$emit("input", newValue);
            },
        },
    },
};
</script>

<style lang="scss" scoped>
.google-business-update-review-status {
    padding: 20px;
    display: flex;
    flex-direction: column;
    gap: 10px;

    section {
        margin-bottom: 20px;
    }

    .title {
        font-weight: bold;
        margin-bottom: 5px;
    }

    .classic-select {
        width: 100%;
    }

    small {
        color: #777;
    }
}
</style>
